class AllActionTypes {
  static LOADER_STATE_TRUE = "LOADER_STATE_TRUE";
  static LOADER_STATE_FALSE = "LOADER_STATE_FALSE";
  static TOGGLE_SIDEBAR = "TOGGLE_SIDEBAR";
  static TOGGLE_CLIENTS = "TOGGLE_CLIENTS";
  static LOGIN_SUCCESS = "LOGIN_SUCCESS";
  static LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
  static INCREASE_FONT_SIZE = "INCREASE_FONT_SIZE";
  static DECREASE_FONT_SIZE = "DECREASE_FONT_SIZE";
  static SET_FONT_SIZE = "SET_FONT_SIZE";
  static SET_CURRENT_POSITION="SET_CURRENT_POSITION"
}
export default AllActionTypes;
